/**
 * Content tab values and stable `deltaMode` strings for {@link ./fintelDeltaRunContext.js}
 * (`X-AWP-Operation-Run-Id` is scoped per reportId + deltaMode). Each distinct mode must map to its
 * own string so Timeline and Claims do not share one audit operation.
 *
 * Claims, Timeline, and Gaps are flat top-level tabs.
 * URL `fintelTab` uses these values (claims | timeline | gaps).
 */
export const DeltaPanelTab = {
    /** Report-aware claim clusters (POST /api/entities/delta-clusters). */
    CLAIMS: 'claims',
    /** Reverse-chronological updates (POST /api/entities/delta-timeline). */
    TIMELINE: 'timeline',
    /** FINTEL Gaps-section statements → standalone EEIs. */
    GAPS: 'gaps',
};

/** Maps MUI tab `value` → `deltaMode` passed to delta API helpers. */
export const DELTA_TAB_TO_MODE = {
    [DeltaPanelTab.CLAIMS]: 'claims',
    [DeltaPanelTab.TIMELINE]: 'timeline',
    [DeltaPanelTab.GAPS]: 'gaps',
};

/**
 * @param {string | null | undefined} tabValue — `Tabs` value from Delta panel
 * @returns {string} stable deltaMode for {@link ./fintelDeltaRunContext.js}
 */
export function deltaModeForActiveTab(tabValue) {
    if (tabValue == null || tabValue === '') {
        return DELTA_TAB_TO_MODE[DeltaPanelTab.CLAIMS];
    }
    const mode = DELTA_TAB_TO_MODE[tabValue];
    return mode != null ? mode : DELTA_TAB_TO_MODE[DeltaPanelTab.CLAIMS];
}
